import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ButtonBack } from 'shared/components/Buttons/ButtonBack';
import { SellerForm } from '../components/SellerForm';
import { SellerInfo } from '../components/SellerInfo';
import { accountOracleActions } from '../stores';
import { PageContainer } from 'shared/GlobalStyles';

/**
*  Details Seller
*/
export const SellerDetails: FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(accountOracleActions.loadSellerByBirCode());
    }, []);

    return (
        <PageContainer>
            <ButtonBack linkTo="/accounts/tracking" />
            <h4>{t("Account.Details.SellerInfo")}</h4>
            <SellerInfo />
            <SellerForm />
        </PageContainer>
    );
}